
import { Component, Watch } from "vue-property-decorator";
import { StaffModel } from "@/models/StaffModel";
import BaseView from "./baseView";
import Vue from "vue";
import * as Contentful from "contentful";
import { ContentfulClientApi } from "contentful";
import AppStorage from "@/AppStorage";
import AwesomePhonenumber from "awesome-phonenumber";

@Component({
    components: {}
})
export default class Milou extends BaseView {
    public employees: StaffModel[] = [];
    public storage: AppStorage = Vue.AppStorage;
    public employeesOriginal = "";
    public filter = "";
    public timer = 0;
    contentfulClient: ContentfulClientApi = Contentful.createClient({
        space: this.storage.contentfulSpace,
        accessToken: this.storage.contentfulAccessToken
    });

    @Watch("filter")
    public onFilterChange() {
        const filterDelay = 300;
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => {
            if (this.filter) {
                this.employees = JSON.parse(this.employeesOriginal);
                this.employees.forEach(item => {
                    const fieldsToSearch = item.name + item.phone + item.title + item.office;
                    if (fieldsToSearch.toLocaleLowerCase().indexOf(this.filter.toLocaleLowerCase()) > -1) {
                        Vue.set(item, "hide", false);
                    } else {
                        Vue.set(item, "hide", true);
                    }
                });
            } else {
                this.employees = JSON.parse(this.employeesOriginal);
            }
        }, filterDelay);
    }

    displayPhoneLink(phone: string): string {
        return new AwesomePhonenumber(phone, "SE").getNumber("rfc3966");
    }

    displayPhone(phone: string): string {
        return new AwesomePhonenumber(phone, "SE").getNumber("national");
    }

    parseEmployees(response: any): StaffModel[] {
        const employees: StaffModel[] = [];
        response.items.forEach((item: any) => {
            employees.push({
                name: item.fields.name,
                title: item.fields.title,
                email: item.fields.email,
                phone: item.fields.phone,
                photo: item.fields.photo.fields.file.url,
                office: item.fields.office
            });
        });

        return employees;
    }

    public mounted() {
        this.contentfulClient
            .getEntries({
                // eslint-disable-next-line @typescript-eslint/camelcase
                content_type: "employee",
                order: "fields.name"
            })
            .then(response => {
                this.employeesOriginal = JSON.stringify(this.parseEmployees(response));
                this.employees = this.parseEmployees(response);
            });
        (this.$refs.search as HTMLElement).focus();
    }
}
